import 'primereact/resources/themes/lara-light-blue/theme.css'
// PrimeIcons loaded from CDN in index.html for TailwindCSS v4 compatibility
import { ThemeProvider } from './contexts/ThemeContext'
import { AppRoutes } from './routes/AppRoutes'
import Navbar from './components/navbar'

export default function App() {
  return (
    <ThemeProvider>
      <Navbar />
      <AppRoutes />
    </ThemeProvider>
  )
}
